<template>
  <div>
    <loading v-show="showLoading"></loading>
    <div v-show="!showLoading">
      <!--首页搜索-->
      <div class="nav_bar clear_both">
<!--        <button class="clear_style fl nav_bar_left_item" style="width: 2rem;height: 2rem" ><img class="nav_item_btn" src="@/images/back.png" @click="$router.back(-1)" ></button>-->
        <div class="clear_style fl nav_bar_search" @click="popSearchView()">
          <img  src="@/images/icon_search.png">
          <span>hello kitty 公仔</span>
        </div>
      </div>
      <div class="home_content">
        <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
          <!--分类-->
          <div class="clear_both">
            <van-tree-select
              height="45rem"
              :items="items"
              :main-active-index.sync="activeIndex"
            >
              <template slot="content">
                <div v-for="(classifyItem, index) in productCatagoryList" v-if="activeIndex === index" :key="index">
                  <div class="clear_both" style="width: 17.4rem;padding: 0.7rem 0">
                    <div class="content_container" v-if="classifyItem.adv.length">
                      <!--banner-->
                      <van-swipe :show-indicators="false" :autoplay="3000" >
                        <van-swipe-item style="border-radius: 0.5rem" v-for="(advItem, advIndex) in classifyItem.adv" :key="advIndex">
                          <van-image class="banner_Item" @click="pushWebUrl(advItem.contentUrl)" fit="cover" :src="advItem.imageUrl"/>
                        </van-swipe-item>
                      </van-swipe>
                    </div>

                    <div class="classify_Item fl" v-for="(childrenItem, childIndex) in classifyItem.childrenList" :key="childIndex">
                      <router-link :to="{path:'/productList',query:{productCategoryId:childrenItem.productCategoryId}}">
                        <van-image class="classify_Item_img" style="background-color: #f5f5f5;" :src="childrenItem.categoryImageUrl" />
                        <p style="text-align: center;font-size: 0.75rem">{{childrenItem.categoryName}}</p>
                      </router-link>
                    </div>
                  </div>
                </div>
              </template>
            </van-tree-select>
          </div>
        </van-pull-refresh>
      </div>
    </div>
    <div class="home_search" v-show="isShowSearch">
      <form action="/">
        <van-search
          class="search_br"
          shape="round"
          placeholder="hello kitty 公仔"
          show-action
          @search="searchAction()"
          v-model="searchValue"
          @cancel="dismissSearchView"
        />
      </form>
      <div class="content_container" >
        <p class="zt12">热门搜索</p>
        <ul class="tag_list" >
          <li class="fl" v-for="(tagItem, index) in tagList" :key="index"><router-link :to="{path:'/productList', query:{keyWord:tagItem.keyword}}"><span class="tag_item zt12">{{tagItem.keyword}}</span></router-link></li>
          <transition name="router-slid" mode="out-in">
            <router-view></router-view>
          </transition>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>

  import Vue from 'vue';
  import { storeName,prodCatalogId } from '@/router/Constant'
  import { NavBar,Image,Tabbar,TreeSelect,PullRefresh,Search,Toast,Swipe,SwipeItem } from 'vant';
  import { getProductCategory,getKeyword,login } from '@/router/api';
  import footerView from '../common/footer'
  import loading from '@/components/page/common/loading.vue'

  export default {
    name: 'classify',

    data() {
      return {
        images1:[
          "https://kitty.choicelean.com/images/adv/10000_adv_image/15747528837761.png",
          "https://kitty.choicelean.com/images/adv/10000_adv_image/1574752883772.png",
          "https://kitty.choicelean.com/images/adv/10000_adv_image/1574752883776.png"
        ],

        searchValue:"",
        showLoading:true,
        isLoading: false,
        isShowSearch: false,
        activeIndex: 0,
        productCatagoryList: [],
        tagList: [],
        items: [],
        productStoreId: storeName,
        prodCatalogId:prodCatalogId,
      }
    },

    components: {
      [NavBar.name]: NavBar,
      [Image.name]: Image,
      [Tabbar.name]: Tabbar,
      [Search.name]: Search,
      [TreeSelect.name]: TreeSelect,
      [PullRefresh.name]: PullRefresh,
      [Toast.name]: Toast,
      [Swipe.name]: Swipe,
      [SwipeItem.name]: SwipeItem,
      footerView,
      loading,
    },

    methods: {
      async initData() {
        this.getProductCategory();
        // this.getKeyword();
      },
      // 弹出搜索框
      popSearchView: function () {
        this.isShowSearch = true;
        document.querySelector('body').setAttribute('style', 'overflow:hidden');
      },
      // 隐藏框搜索框
      dismissSearchView: function () {
        this.isShowSearch = false;
        document.querySelector('body').removeAttribute('style');
      },
      //下拉刷新
      onRefresh() {
        setStore('onRefresh',"onRefresh")
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      },
      pushWebUrl(url) {
        if (url){
          window.location.href = url;
        } else {
          Toast("请设置正确跳转链接");
        }
      },
      getProductCategory() {
        getProductCategory({token:"",productStoreId:this.productStoreId,prodCatalogId:this.prodCatalogId})
          .then(res => {
            if (res.productCategoryList) {
              console.log(res.productCategoryList)
              this.productCatagoryList = res.productCategoryList;
              var list = res.productCategoryList;
              for (let i=0;i < list.length;i++) {
                var item = {text : this.productCatagoryList[i].categoryName}
                this.items.push(item);
              }

              for(var i = 0; i<res.productCategoryList.length;i++){
                var obj = {categoryName:'全部',categoryImageUrl:this.productCatagoryList[i].linkOneImageUrl,productCategoryId:this.productCatagoryList[i].productCategoryId}
                res.productCategoryList[i].childrenList.splice(0,0,obj)
              }

              setTimeout(() => {
                this.showLoading = false;

              }, 1000);
            } else {
              Toast(res._ERROR_MESSAGE_);
            }
          })
          .catch(err => {
            console.log(err);
          });
      },
      getKeyword() {
        getKeyword({token:"",productStoreId:this.productStoreId,prodCatalogId:this.prodCatalogId})
          .then(res => {
            this.tagList = res.kryWordList
          })
          .catch(err => {
            console.log(err);
          });
      },
      searchAction(){
        this.$router.push({path:'/productList',query:{keyWord:this.searchValue}})
      },
    },
    mounted() {
      this.initData()
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

  .home_content {
    padding-top: 3rem
  }

  .content_container {
    padding: 0 0.8rem
  }

  .search_br > .van-search__content {
    border-radius: 2rem;
  }

  .van-sidebar {
    width: 5rem;
  }

  .van-tree-select__nav {
    -webkit-box-flex: 0.7;
    -webkit-flex: 0.7;
    flex: 0.7;
  }

  .van-tree-select__nav-item {
    padding: 1rem 0rem 1rem 0rem;
    text-align: center;
  }

  .banner_Item {
    width: 15.5rem;
    height: 6.8rem;
  }

  .classify_Item {
    width: 4.375rem;height: 6.5rem;margin: 0.7rem;
  }

  .classify_Item_img {
    width: 4.375rem;height: 4.375rem;clear: both;overflow: hidden;border-radius: 0.5rem;
  }

  .nav_bar {
    padding-top: 0.5rem;padding-bottom: 0.5rem;position: fixed;z-index: 99;width: 100%;background-color: white;border-bottom: 1px solid #eaeaea;
  }

  .nav_bar_left_item {
    padding-top: 0.3rem;
  }

  .nav_item_btn {
    width: 1.25rem;height: 1.25rem;
  }

  .nav_bar_search {
    width: 21.05rem;background-color: #f5f5f5;height: 2rem;line-height: 2rem;padding: 0 0.8rem;border-radius: 1rem;
    margin-left: 0.35rem;
  }

  .nav_bar_search > img {
    width: 0.8rem;height: 0.8rem;margin-right: 0.5rem;
  }

  .nav_bar_search > span {
    font-size: 0.75rem;color: #999999;
  }

  .nav_bar_right_item {
    padding-top: 0.3rem;
  }

  .tag_list > li {
    line-height: 2rem;
    margin: 0 0.6rem 0.6rem 0;
  }

  .tag_item {
    background-color: #f5f5f5;padding: 0.5rem 1rem;border-radius: 0.3rem;
  }

  .home_search {
    width: 100%;height: 100%;position: fixed;top: 0;background-color: white;z-index: 99;
  }

  .classify_banner {
    background-color: #f5f5f5;width: 15.5rem;height: 6.8rem;border-radius: 0.5rem;
  }

  .van-sidebar-item {
    font-size: 0.75rem;
  }

</style>



// WEBPACK FOOTER //
// src/components/page/home/classify.vue